// -------------------------------------------------------------------< constants >-------------------------------------------------------------------
const TEST_GET_DATA_SUCCESS = 'TEST_GET_DATA_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getDataSuccess(payload) {
  return {
    type: TEST_GET_DATA_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {String} [url]
 * @param {Object} [data]
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function get(url, data = {}, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    api.get(url, {data, params})
      .then((res) => {
        //console.log(res);
       // dispatch(_getDataSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        callback(err);
      });
  };
}
/**
 *
 * @param {String} [url]
 * @param {Object} [data]
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function post(url, data = {}, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    api.post(url, {data, params})
      .then((res) => {
        // dispatch(_getDataSuccess(res));
        callback(undefined, res);
      })
      .catch((err) => {
        console.log('err', err);
        callback(err);
      });
  };
}
// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------

/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(state = {
  data: {},
}, action) {
  switch (action.type) {
    case TEST_GET_DATA_SUCCESS:
      return Object.assign({}, state, {
        data: action.payload,
      });
    default:
      return state;
  }
}
